import React from 'react'
import {
  FieldErrorAndDescription,
  FieldErrorAndDescriptionProps,
} from './form/field-error-and-description'
import { FieldLabel, FieldLabelProps } from './form/field-label'

type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> &
  FieldErrorAndDescriptionProps &
  FieldLabelProps & {
    isLoading?: boolean
  }

function FormTextarea({
  label,
  labelClassName,
  value,
  rows,
  className,
  onChange,
  onFocus,
  maxLength,
  error,
  placeholder,
  required,
  description,
  isLoading,
  ...rest
}: TextareaProps) {
  return (
    <label className="flex flex-col gap-1 text-sm font-medium">
      <FieldLabel label={label} required={required} labelClassName={labelClassName} />
      <textarea
        className={`text-text-primary main-transition-colors w-full rounded-lg border ${
          error ? 'border-danger' : 'border-text-secondary/30'
        } focus:border-brand-primary placeholder:text-text-tertiary/70 px-4 py-2.5 focus:outline-hidden ${
          className || ''
        } resize-none ${
          isLoading
            ? 'bg-skeleton-primary/40 disabled:bg-skeleton-primary/40 animate-pulse text-transparent'
            : 'disabled:bg-background-tertiary/40'
        }`}
        value={value}
        rows={rows || 5}
        onChange={onChange}
        onFocus={onFocus}
        maxLength={maxLength}
        placeholder={placeholder}
        spellCheck={false}
        disabled={rest.disabled}
      />
      <FieldErrorAndDescription description={description} error={error} />
    </label>
  )
}

export default FormTextarea
